import { render, staticRenderFns } from "./DataCollectionMappingConfig.vue?vue&type=template&id=4c9f3d5c&scoped=true&"
import script from "./DataCollectionMappingConfig.vue?vue&type=script&lang=js&"
export * from "./DataCollectionMappingConfig.vue?vue&type=script&lang=js&"
import style0 from "./DataCollectionMappingConfig.vue?vue&type=style&index=0&id=4c9f3d5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9f3d5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VForm,
  VTextField,
})
